import { Injectable } from '@angular/core';

@Injectable()
export class NumberService {

  zeroPad(num: number, length: number): string {
    let str = num.toString();
    while (str.length < length) {
      str = `0${str}`;
    }
    return str;
  }

  thousandSeparator(n: any) {
    if (Number(n) == 0) {
      n = "";
    }
    let numberString = Number(n).toFixed(2);
    return (n != "") ? numberString.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : 0.00;
  }

  formatNumber(strNumber: any): number {
    let n = parseFloat(strNumber.toString().replaceAll(",", "").replaceAll(" ", ""));
    if (!n) {
      return 0;
    }
    return Number(n);
  }

  isNumber(n: string): boolean {
    return !isNaN(parseFloat(n)) && isFinite(Number(n));
  }

  getArraySum(data: Array<number>): number {
    return (data.length == 0) ? 0 : Number(data.reduce((a: number, b: number) => a + b).toFixed(2));
  }
}
